import 'css-chunk:src/index/pages/task_csvregist/index.module.scss';export default {
  "tablet": "tablet__mJptK",
  "sp": "sp__DhW2x",
  "pc": "pc__giM2o",
  "pcTablet": "pcTablet__I9jy3",
  "section": "section__lLuqJ",
  "relative": "relative__yjDFa",
  "row": "row__i20kd",
  "middle": "middle__Rh1Ek",
  "formLabel": "formLabel__0igjd",
  "formLabel2": "formLabel2__RNiyG",
  "formLabelIssue": "formLabelIssue__CNnT7",
  "sectionCSV": "sectionCSV__hvSkZ",
  "editarea": "editarea__7GxE5",
  "show": "show__60XOV",
  "upload": "upload__DIPB0",
  "info": "info__bLG0A",
  "active": "active__UpnZg",
  "searchBox": "searchBox__x6t0p",
  "hide": "hide__nJV4C",
  "menuShowBtn": "menuShowBtn__H6yv3",
  "error": "error__jHYAh"
};